module.exports = __webpack_public_path__ + "img/manda_003.7730dd42.png";